const colors = {
  UNPAID: 'bg-yellow-secondary bg-opacity-10 text-yellow-secondary ',
  PAID: 'bg-green-subtle text-green-success',
  REFUND: 'bg-red-subtle text-red-secondary',
  PARTIAL_REFUND: 'bg-red-subtle text-red-primary',
  EXPIRED: 'text-grey-dark bg-grey-dark bg-opacity-10',
  CANCELED: 'text-grey-dark bg-grey-dark bg-opacity-10',
  RESCHEDULED: 'bg-green-subtle text-green-success',
}

const statusOptions = [
  'UNPAID',
  'PAID',
  'REFUND',
  'PARTIAL_REFUND',
  'EXPIRED',
  'CANCELED',
  'RESCHEDULED'
]

const PAYMENT_METHODS = [
	"...",    
	"Cash",    
	"Transfer", 
	"EDC",      
	"QRIS",  
  "Midtrans",
]

export {
  colors,
  statusOptions,
  PAYMENT_METHODS
}
